/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".search-tips[_ngcontent-%COMP%]{position:relative;top:38px;left:-140px;background-color:rgba(0,0,0,.85);margin:10px;display:block;width:260px;padding:10px;border-radius:5px;color:#fff;font-size:14px;z-index:1}.search-tips[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:16px;font-weight:700;margin-bottom:10px}.search-tips[_ngcontent-%COMP%]   .tips[_ngcontent-%COMP%]{margin-bottom:15px}"];
export { styles as styles };
